import styles from "./styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import BackInStockTick from "../../assets/back-in-stock-tick.svg";
import EditHanger from "../../assets/edit-hanger.svg";
import StyleMatchTshirt from "../../assets/stylematch-t-shirt.svg";
import ReturnsArrow from "../../assets/returns-arrow.svg";

export default function Perks() {
  const translate = useTranslate(useLocaleProvider());
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2>{translate("ourapps_perks_title")}</h2>
      </div>
      <div className={styles.perksContainer}>
        <div className={styles.perkItem}>
          <div className={styles.icon}>
            <BackInStockTick
              alt={translate("ourapps_perks_backinstock_tick_icon_alt_text")}
            />
          </div>
          <div className={styles.perkText}>
            <h3>{translate("ourapps_perks_backinstock_title")}</h3>
            <p>{translate("ourapps_perks_backinstock_desc")}</p>
          </div>
        </div>
        <div className={styles.perkItem}>
          <div className={styles.icon}>
            <EditHanger
              alt={translate("ourapps_perks_youredit_icon_alt_text")}
            />
          </div>
          <div className={styles.perkText}>
            <h3 className={styles.wordBreak}>
              {translate("ourapps_perks_youredit_title")}
            </h3>
            <p>{translate("ourapps_perks_youredit_desc")}</p>
          </div>
        </div>
        <div className={styles.perkItem}>
          <div className={styles.icon}>
            <StyleMatchTshirt
              alt={translate("ourapps_perks_stylematch_icon_alt_text")}
            />
          </div>
          <div className={styles.perkText}>
            <h3 className={styles.wordBreak}>
              {translate("ourapps_perks_stylematch_title")}
            </h3>
            <p>{translate("ourapps_perks_stylematch_desc")}</p>
          </div>
        </div>
        <div className={styles.perkItem}>
          <div className={styles.icon}>
            <ReturnsArrow
              alt={translate("ourapps_perks_orderandreturns_icon_alt_text")}
            />
          </div>
          <div className={styles.perkText}>
            <h3>{translate("ourapps_perks_orderandreturns_title")}</h3>
            <p>{translate("ourapps_perks_orderandreturns_desc")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
